import SvgFeeInfo from "./promo-icons/SvgFeeInfo";
import PromoInput from "./PromoInput";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  promoCode: string;
  promoDiscount: number;
  mobile: boolean;
  countryCode: string;
}

const Promo: React.FC<Props> = ({
  promoCode,
  promoDiscount,
  mobile,
  countryCode,
}) => {
  const t = useTranslation();
  const getCompany = useGetCompanyQuery();
  const showCouponField =
    getCompany.data?.result?.theme?.components.cart.show_coupon_field;
  if (!showCouponField) return null;
  return (
    <div className={`promo${mobile ? "-mobile" : ""}`}>
      <div className="promo-title">{t.got_promotional_code}</div>
      <PromoInput
        promoCode={promoCode}
        promoDiscount={promoDiscount}
        country_code={countryCode}
      />
      <div className="address-info-fees">
        <SvgFeeInfo />
        {t.add_address_calculate_shipping_fees}
      </div>
    </div>
  );
};

export default Promo;
